import type { Action } from 'vuex'
import type { State } from './state'

import actionTypes from './actionTypes'
import { UnderTitleMessageType } from '@/enums/messageEnum'

const actions: { [actionType: string]: Action<State, any> } = {
  [actionTypes.SET_PAGE_MESSAGES]: (
    { commit },
    payload: { messages: string[]; messageType: UnderTitleMessageType }
  ): void => {
    commit(actionTypes.SET_MESSAGE_TYPE, payload.messageType)
    commit(actionTypes.SET_PAGE_MESSAGES, payload.messages)
  },

  [actionTypes.ADD_PAGE_MESSAGE]: (
    { commit },
    payload: { message: string; messageType: UnderTitleMessageType }
  ): void => {
    commit(actionTypes.SET_MESSAGE_TYPE, payload.messageType)
    commit(actionTypes.ADD_PAGE_MESSAGE, payload.message)
  },

  [actionTypes.DELETE_ONE_PAGE_MESSAGE]: (
    { commit },
    payload: { message: string; messageType: UnderTitleMessageType }
  ): void => {
    commit(actionTypes.SET_MESSAGE_TYPE, payload.messageType)
    commit(actionTypes.DELETE_ONE_PAGE_MESSAGE, payload.message)
  },

  [actionTypes.CLEAR_PAGE_MESSAGE]: ({ commit }): void => {
    commit(actionTypes.SET_MESSAGE_TYPE, UnderTitleMessageType.ERROR)
    commit(actionTypes.CLEAR_PAGE_MESSAGE)
  },

  [actionTypes.SET_BALLON_MESSAGE_LAST_TYPE]: ({ commit }, type: string): void => {
    commit(actionTypes.SET_BALLON_MESSAGE_LAST_TYPE, type)
  },
}

export default actions
